var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-kng-operator__cover" },
    [
      _c("yxt-image", { attrs: { src: _vm.coverUrl } }),
      _c(
        "div",
        {
          staticClass: "yxtbiz-kng-operator__cover-set standard-size-12",
          on: { click: _vm.set },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("pc_biz_setCover" /** 设置封面 */)) +
              "\n  "
          ),
        ]
      ),
      _c("cover-drawer", { ref: "drawer" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }